"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DriverTermsAndConditionsType = void 0;
var DriverTermsAndConditionsType;
(function (DriverTermsAndConditionsType) {
    DriverTermsAndConditionsType["TermsAndConditions"] = "termsAndConditions";
    DriverTermsAndConditionsType["PrivacyPolicy"] = "privacyPolicy";
})(DriverTermsAndConditionsType || (exports.DriverTermsAndConditionsType = DriverTermsAndConditionsType = {}));
//# sourceMappingURL=driver-terms-and-conditions-type.enum.js.map